// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1uDPi","row":"Node_row__a-2gv","label":"Node_label__3rO2r","footer":"Node_footer__foNON"};